import { OrdersApiRemoteService } from '../../Services/api/orders/orders-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ExportInPickingOrderUseCase
implements IFormUsecase<void, void> {
  constructor (private readonly ServiceOrdersApi: OrdersApiRemoteService) {}
    

  public async handle (): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ServiceOrdersApi.exportInPickingList()

      if (response.isFailure) {
        return Result.fail(response.error as Error)
      }

      // Criar o nome do arquivo com a data atual
      const currentDate = new Date()
      const day = String(currentDate.getDate()).padStart(2, '0')
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const year = currentDate.getFullYear()
      const fileName = `pedidos-${day}-${month}-${year}.pdf`

      // Criar URL do blob e fazer download automático
      const blob = response.getValue() as Blob
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
